export const FETCH_GRADE_START = 'FETCH_GRADE_START'
export const FETCH_GRADE_SUCCESS = 'FETCH_GRADE_SUCCESS'
export const FETCH_GRADE_FAILED = 'FETCH_GRADE_FAILED'

export const FETCH_GRADE_BY_ID_START = 'FETCH_GRADE_BY_ID_START'
export const FETCH_GRADE_BY_ID_SUCCESS = 'FETCH_GRADE_BY_ID_SUCCESS'
export const FETCH_GRADE_BY_ID_FAILED = 'FETCH_GRADE_BY_ID_FAILED'

export const CLEAR_SELECTED_GRADE_RECORD = 'CLEAR_SELECTED_GRADE_RECORD'

export const CREATE_GRADE_START = 'CREATE_GRADE_START'
export const CREATE_GRADE_SUCCESS = 'CREATE_GRADE_SUCCESS'
export const CREATE_GRADE_FAILED = 'CREATE_GRADE_FAILED'

export const UPDATE_GRADE_START = 'UPDATE_GRADE_START'
export const UPDATE_GRADE_SUCCESS = 'UPDATE_GRADE_SUCCESS'
export const UPDATE_GRADE_FAILED = 'UPDATE_GRADE_FAILED'

export const DELETE_GRADE_START = 'DELETE_GRADE_START'
export const DELETE_GRADE_SUCCESS = 'DELETE_GRADE_SUCCESS'
export const DELETE_GRADE_FAILED = 'DELETE_GRADE_FAILED'
